export const DATEX_TENANTID = '0cd4978c-db83-4ffe-8821-f01a5f8110ac';
export const DATEX_APPLICATION_API_CLIENTID = 'bcf89c41-81cc-49ef-b771-ed5ec9e1e5e4';
export const DATEX_APPLICATION_LICENSING_API_CLIENTID = '48051c65-485d-4f17-a557-7df7d9a917ef';
